// frontend/src/components/LCA/Stepper/index.js

export const stepConfig = {
    // Initial step configuration
    enableLifecycleStage: false, // Set to false to skip this step
    
    // Define all possible steps (including disabled ones)
    allSteps: [
      {
        id: 'lifecycle-stage',
        label: 'Select Lifecycle Stage',
        component: 'LifecycleStageSelector',
        path: 'lifecycle-stage',
        enabled: false, // Will be updated based on enableLifecycleStage
        validateFn: (lcaData) => !!lcaData.lifecycleStage
      },
      {
        id: 'solution',
        label: 'Select Solution',
        component: 'SolutionSelector',
        path: 'solution',
        enabled: true,
        validateFn: (lcaData) => !!lcaData.selectedSolution
      },
      {
        id: 'provider',
        label: 'Select Provider',
        component: 'ProviderSelector',
        path: 'provider',
        enabled: true,
        validateFn: (lcaData) => !!lcaData.selectedProvider
      },
      {
        id: 'transport',
        label: 'Transport & Emissions',
        component: 'TransportEmissionsCalculator',
        path: 'transport',
        enabled: true,
        validateFn: (lcaData) => !!lcaData.transportResult
      },
      {
        id: 'report',
        label: 'Environmental Impact Report',
        component: 'LCAReportViewer',
        path: 'report',
        enabled: true,
        validateFn: () => true // Report doesn't require validation
      }
    ],
    
    // Function to get active steps
    getActiveSteps() {
      // Update the lifecycle stage step based on configuration
      this.allSteps[0].enabled = this.enableLifecycleStage;
      
      // Filter only enabled steps
      return this.allSteps.filter(step => step.enabled);
    }
  };
  
  // Export individual components for convenience
  export { default as LifecycleStageSelector } from './LifecycleStageSelector.vue';
  export { default as SolutionSelector } from './SolutionSelector.vue';
  export { default as ProviderSelector } from './ProviderSelector.vue';
  export { default as TransportEmissionsCalculator } from './TransportEmissionsCalculator.vue';
  export { default as LCAReportViewer } from './LCAReportViewer.vue';